import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AuthService } from 'app/core/auth.service';
import { SchedulingDialogComponent } from 'app/forum/dialogs/scheduling-dialog/scheduling-dialog.component';
import { ForumPost } from 'app/forum/models/forum-post';
import { PostFormService } from 'app/forum/services/post-form.service';
import { DestroyComponent } from 'app/shared-ui/base/destroy/destroy.component';
import { MondoUser } from 'app/shared/models/user/mondoUser';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-post-step-view',
  templateUrl: './post-step-view.component.html',
  styleUrls: ['./post-step-view.component.scss'],
})
export class PostStepViewComponent extends DestroyComponent implements OnInit {
  @Input() updatingPost = false;
  @Input() post: ForumPost;
  postFormValue: ForumPost;
  user: MondoUser;

  constructor(
    public postFormService: PostFormService,
    private authService: AuthService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.user = this.authService.getCurrentUser();
    this.postFormValue = this.postFormService.getForm().value;

    this.safeSubscribe(this.postFormService.getFormChangeStream(), (post) => {
      this.postFormValue = post;
      this.cdr.markForCheck();
    });
  }

  OpenPlanForLaterDialog() {
    const dialogRef = this.dialog.open(SchedulingDialogComponent, {
      width: '90vw',
      maxWidth: '550px',
      panelClass: 'schedule-post-dialog',
      disableClose: true,
    });

    return new Promise((resolve) => {
      dialogRef
        .afterClosed()
        .pipe(take(1))
        .toPromise()
        .then((plannedAt) => {
          this.planForLater(plannedAt);
        });
    });
  }

  planForLater(plannedAt: number) {
    this.postFormService
      .getForm()
      .getSafeControl((x) => x.plannedAt)
      .setValue(plannedAt);
  }
}
